import React, { useRef } from 'react';
import HomePageWeb from './HomePageWeb.component';
import HomePageMobileWeb from './HomePageMobileWeb.component';
import useDevicePlatform, {
	DeviceType,
} from '../../hooks/useDevicePlatform.hook';
import { HomePageMonthlyHoursDataResponse, HomePageReportContentElType, HomePageWeeklyHoursDataResponse } from './HomePage.container';
import { Employee101Data } from '../ReportPDFPage/ReportPDFPage.utils';
import { MonthAttendanceResponse } from '../../services/hooks/useMonthAttendance.hook';
export interface HomePageProps {
	openDrawer: () => void;
	showProjectList: boolean;
	navigation: any;
	setShowProjectList?: (val: boolean) => void;
	isSummaryOnly: boolean;
	isPaycheckBlockShown: boolean;
	reportDateYear: string;
	reportContentData: HomePageReportContentElType;
	report101warning: boolean;
	form101Id: string | null;
	form101Status: boolean | null;
	form101StatusCode: Employee101Data['statusCode'] | null;
	form101LastUpdate: Date | null;
	monthlyAttendanceData: MonthAttendanceResponse | null;
	monthlyHoursData: HomePageMonthlyHoursDataResponse[] | null;
	weeklyData: HomePageWeeklyHoursDataResponse[] | null;
}
const HomePageContainer = ({
	navigation,
	openDrawer,
	showProjectList,
	setShowProjectList,
	isSummaryOnly,
	isPaycheckBlockShown,
	reportDateYear,
	reportContentData,
	report101warning,
	form101Id,
	form101Status,
	form101StatusCode,
	form101LastUpdate,
	monthlyAttendanceData,
	monthlyHoursData,
	weeklyData,
}: HomePageProps) => {
	const devicePlatformRef = useRef<DeviceType>(useDevicePlatform());

	return (
		<>
			{devicePlatformRef.current === DeviceType.MOBILE_WEB ? (
				<HomePageMobileWeb
					navigation={navigation}
					openDrawer={openDrawer}
					showProjectList={showProjectList}
					setShowProjectList={setShowProjectList}
					isSummaryOnly={isSummaryOnly}
					isPaycheckBlockShown={isPaycheckBlockShown}
					reportDateYear={reportDateYear}
					reportContentData={reportContentData}
					report101warning={report101warning}
					form101Id={form101Id}
					form101Status={form101Status}
					form101StatusCode={form101StatusCode}
					form101LastUpdate={form101LastUpdate}
					monthlyAttendanceData={monthlyAttendanceData}
					monthlyHoursData={monthlyHoursData}
					weeklyData={weeklyData}
				/>
			) : (
				<HomePageWeb
					navigation={navigation}
					openDrawer={openDrawer}
					showProjectList={showProjectList}
					setShowProjectList={setShowProjectList}
					isSummaryOnly={isSummaryOnly}
					isPaycheckBlockShown={isPaycheckBlockShown}
					reportDateYear={reportDateYear}
					reportContentData={reportContentData}
					report101warning={report101warning}
					form101Id={form101Id}
					form101Status={form101Status}
					form101StatusCode={form101StatusCode}
					form101LastUpdate={form101LastUpdate}
					monthlyAttendanceData={monthlyAttendanceData}
					monthlyHoursData={monthlyHoursData}
					weeklyData={weeklyData}
				/>
			)}
		</>
	);
};

export default HomePageContainer;
